import { render, staticRenderFns } from "./home_comb.vue?vue&type=template&id=388c60e8&scoped=true"
import script from "./home_comb.vue?vue&type=script&lang=js"
export * from "./home_comb.vue?vue&type=script&lang=js"
import style0 from "./home_comb.vue?vue&type=style&index=0&id=388c60e8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388c60e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388c60e8')) {
      api.createRecord('388c60e8', component.options)
    } else {
      api.reload('388c60e8', component.options)
    }
    module.hot.accept("./home_comb.vue?vue&type=template&id=388c60e8&scoped=true", function () {
      api.rerender('388c60e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_comb.vue"
export default component.exports